import { render, staticRenderFns } from "./AlbumsForm.vue?vue&type=template&id=cbba55b6"
import script from "./AlbumsForm.vue?vue&type=script&lang=js"
export * from "./AlbumsForm.vue?vue&type=script&lang=js"
import style0 from "./AlbumsForm.vue?vue&type=style&index=0&id=cbba55b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports